module.exports = __webpack_public_path__ + "static/img/6-03.b54a669.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/custDetail/6-03.png
// module id = I5/Y
// module chunks = 1